import { IntegrationLogReportReducer, IntegrationLogReportReducerDispatch, IntegrationLogReportReduxTypes } from "./types"

const CREATE_REPORT_INIT_STATE = {
    data: {},
    loading: false,
    error: null
}

const CreateIntegLogReportReducer = (state: IntegrationLogReportReducer = CREATE_REPORT_INIT_STATE, action: IntegrationLogReportReducerDispatch) => {
    switch (action.type) {
        case IntegrationLogReportReduxTypes.INTEG_LOG_REPORT: {
            return {
                ...state,
                loading: true
            }

        }
        case IntegrationLogReportReduxTypes.INTEG_LOG_REPORT_SUCCESS: {
            return {
                ...state,
                data: action.payload.data,
                loading: false
            }
        }
        case IntegrationLogReportReduxTypes.INTEG_LOG_REPORT_ERROR: {
            return {
                data: {},
                error: action.payload.error,
                loading: false
            }
        }
        default:
            return {...state};
    }
}

export {CreateIntegLogReportReducer}